import { BiUpArrowAlt, BiDownArrowAlt } from "react-icons/bi";

/**
 * Up/down reorder buttons, meant for a DataGrid `renderCell` column pair.
 * Pair with `useReorderableList` for the actual array logic.
 */
export const ReorderArrows = ({
  onMoveUp,
  onMoveDown,
  canMoveUp = true,
  canMoveDown = true,
  size = 30
}) => (
  <div className="flex items-center gap-1">
    <BiUpArrowAlt
      size={size}
      className={canMoveUp ? "action-icon" : "action-icon opacity-30 pointer-events-none"}
      onClick={canMoveUp ? onMoveUp : undefined}
      aria-disabled={!canMoveUp}
    />
    <BiDownArrowAlt
      size={size}
      className={canMoveDown ? "action-icon" : "action-icon opacity-30 pointer-events-none"}
      onClick={canMoveDown ? onMoveDown : undefined}
      aria-disabled={!canMoveDown}
    />
  </div>
);

export default ReorderArrows;
